 <template>
  <SubContent @back="$router.go(-1)">
    <template v-slot:nav_left>
      {{trainPlain.youthShortName}}-{{trainPlain.squadName}}
      <span style="font-size:.16rem;margin-left:20px">{{trainPlain.trainYear}}年度训练计划及总结</span>
    </template>
    <template v-slot:nav_right>

    </template>
    <div class="scroll_wrap">
      <vue-scroll v-show="!loading">
        <div class="item_title" style="padding-top:.2rem">
          {{trainPlain.trainYear}}年度训练计划及总结
        </div>
        <div class="item_title" style="padding-top:.2rem">
          <img src="@/assets/images/common/player_information.png" style="width:23px;height:26px" alt="">
          全年训练基本任务
        </div>
        <div class="item">
          <div class="col">
            <span>{{trainPlain.yearTrainingTask || '--' }}</span>
          </div>
        </div>
        <div class="item_title" style="padding-top:.2rem">
          <img src="@/assets/images/common/player_information.png" style="width:23px;height:26px" alt="">
          训练与比赛目标
        </div>
        <div class="item">
          <div class="col">
            <span>{{trainPlain.trainAndMatchTarget || '--' }}</span>
          </div>
        </div>
        <div class="item_title" style="padding-top:.2rem">
          <img src="@/assets/images/common/player_information.png" style="width:23px;height:26px" alt="">
          训练指导思想
        </div>
        <div class="item">
          <div class="col">
            <span>{{trainPlain.trainIdeology || '--' }}</span>
          </div>
        </div>
        <div class="item_title" style="padding-top:.2rem">
          <img src="@/assets/images/common/player_information.png" style="width:23px;height:26px" alt="">
          训练阶段划分
        </div>
        <div class="item">
          <div class="col">
            <span>{{trainPlain.trainingStageDivision || '--' }}</span>
          </div>
        </div>
        <div class="item_title" style="padding-top:.2rem">
          <img src="@/assets/images/common/player_information.png" style="width:23px;height:26px" alt="">
          训练负荷安排
        </div>
        <div class="item">
          <div class="col">
            <span>{{trainPlain.trainingArrangement || '--' }}</span>
          </div>
        </div>
        <div class="item_title" style="padding-top:.2rem">
          <img src="@/assets/images/common/player_information.png" style="width:23px;height:26px" alt="">
          训练基本手段
        </div>
        <div class="item">
          <div class="col">
            <span>{{trainPlain.trainMeans || '--' }}</span>
          </div>
        </div>
        <div class="item_title" style="padding-top:.2rem">
          <img src="@/assets/images/common/player_information.png" style="width:23px;height:26px" alt="">
          身体测试及综合考核安排
        </div>
        <div class="item">
          <div class="col">
            <span>{{trainPlain.testArrangement || '--' }}</span>
          </div>
        </div>
        <div class="item_title" style="padding-top:.2rem">
          <img src="@/assets/images/common/player_information.png" style="width:23px;height:26px" alt="">
          实施训练计划的具体措施
        </div>
        <div class="item">
          <div class="col">
            <span>{{trainPlain.trainImplement || '--' }}</span>
          </div>
        </div>
        <div class="item_title" style="padding-top:.2rem">
          <img src="@/assets/images/common/player_information.png" style="width:23px;height:26px" alt="">
          可能遇到的问题及困难等
        </div>
        <div class="item">
          <div class="col">
            <span>{{trainPlain.problemsAndDifficulties || '--' }}</span>
          </div>
        </div>
        <div class="item_title" style="padding-top:.2rem">
          <img src="@/assets/images/common/player_information.png" style="width:23px;height:26px" alt="">
          年度训练计划及总结
        </div>
        <div class="item">
          <div class="col">
            <span>{{trainPlain.summaryYear || '--' }}</span>
          </div>
        </div>
      </vue-scroll>
      <yioks-loading v-if="loading"></yioks-loading>
    </div>
  </SubContent>
</template>

<script>

import person from '@/assets/images/common/person.jpg'
import plan from '@/api/plan'
import storage from '@/utils/storage'
import playImg from '@/assets/images/common/playImg.png'
import planImg from '@/assets/images/common/plan_default.png'
export default {
  components: {
    'SubContent': () => import('@/components/layout/newSubContent')
  },
  filters: {
    dataEmpty (val) {
      if (!val) return '--'; else  return val;
    }
  },
  data () {
    return {
      person,
      playImg,
      planImg,
      downIng: false,
      loading: true,
      trainUuid: this.$route.query.uuid,
      uuid: storage.get('userInfo').uuid,
      userRole: storage.get('userInfo').userRole,
      trainPlain: {},
    }
  },
  created () {
    this.getTrainDetail()
  },
  methods: {

    getTrainDetail () {
      plan.getYearTrainDetail(this.trainUuid).then(res => {
        this.loading = false
        if (res.code) {
          this.$message.error('训练计划不存在')
          this.$router.push('/home/index')
        } else {
          this.trainPlain = res
        }
      }).catch(err => {
        this.loading = false
        console.error(err)
      })
    },
  }
}
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  .download_btn
    background $green_color2
    padding .05rem .2rem
    font-size .16rem
    cursor pointer
  .scroll_wrap
    flex 1
    overflow hidden
    box-sizing border-box
    padding .2rem 0
    .item_title
      display flex
      align-items center
      font-size .2rem
      padding .4rem 0 .2rem
      margin 0 .3rem
      span
        margin-left .4rem
        font-size .16rem
      img
        margin-right .1rem
    .item
      border 1px solid #FFF
      margin 0 .3rem
      .head
        font-weight bold
      .center
        text-align center
      .col
        display flex
        border-bottom 1px solid #FFF
        justify-content space-around
        padding .1rem .2rem
        span
          width 100%
        &:last-child
          border none
    .item_link
      border 1px solid #FFF
      margin 0 .3rem
      .col
        display flex
        border-bottom 1px solid #FFF
        &:last-child
          border none
        .title
          width: 1.5rem;
          padding .1rem .05rem
        .flex
          flex 1
          padding .1rem .2rem
          border-left 1px solid #FFF
    .trainPlan
      display flex
      justify-content space-between
      flex-wrap wrap
      margin: 0 .3rem;
      .planDetail
        border  1px solid white
        width 100%
        .row
          min-height 49px
          display flex
          align-items center
          border-bottom 1px solid white
          &:last-child
            border-bottom none
          .col
            width:  50%
            padding 0 10px 0 20px
            height 100%
            line-height 49px
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            &:first-child
              border-right  1px solid white
        .rowLine
          padding: 10px  10px  10px 20px
      .mediaDetail
        background-color rgba(0,0,0,0.7)
        border  1px solid white
        padding  20px
        width 400px
        display flex
        align-items center
        cursor pointer
        margin-bottom 20px
        .p_item
          margin-bottom 10px
      .img
        width 170px
        height 100px
        position relative
        .coverImg
          width 100%
          height 100%
      .intro
        padding-left 10px
        width: calc(100% - 170px);
        height 100px
        display flex
        flex-direction column
        justify-content space-between
    .item_squad
      border 1px solid #FFF
      margin 0 .3rem .2rem
      border-right 0
      display flex
      .flex
        flex 1
      .flex_center
        display flex
        flex-direction column
        justify-content center
        align-items center
        padding 0 .1rem
        border-right 1px solid #FFF
        img
          width .6rem
          height .6rem
          border-radius 50%
          margin-bottom .1rem
        p
          margin-bottom .1rem
      .head,.content
        padding: 0.1rem 0.2rem;
        border-right 1px solid #FFF
        border-bottom 1px solid #FFF
      .content
        min-height .6rem
      .col
        display flex
        justify-content space-around
        border-bottom 1px solid #FFF
        &:last-child
          border none
        span
          width 100%
          text-align center
          border-right 1px solid #FFF
          padding .1rem .2rem

.left-wrapper
  width 100%
  .up-wrapper
    display flex
  .down-wrapper
    .line
      display flex
      border-bottom 1px solid #FFF
      &:last-child
        border-bottom none
      .title-item
        width 100%
        border-right 1px solid #FFF
        padding .1rem .2rem
        display flex
        justify-content center
        align-items center

.player-box
  border 1px solid #FFF
  display flex
  margin 0 .3rem .2rem
  margin-top 15px
  .left-info-box
    width 160px
    display flex
    flex-direction column
    align-items center
    justify-content center
    .head-img-box
      width 100%
      display flex
      flex-direction column
      justify-content center
      align-items center
      .head-img
        width 80px
        height 80px
        border-radius 80px
        margin 0 10px 20px
    .select-box
      margin-top 20px
      padding 5px 10px
      .head-input-label
        display flex
        flex-direction column
        .head-input-label-text
          display flex
          align-items center
          justify-content center
  .right-info-box
    border-left 1px solid #FFF
    width 100%
    .row
      width 100%
      border-bottom 1px solid #FFFFFF
      padding 15px 10px
      display flex
      &:last-child
        border-bottom none
      .label-wrapper
        width 95px
        text-align right
      .input-wrapper
        padding 0 10px
        display flex
        width: 100%
        .input-style
          width 100%

.img-box
  padding 0rem 0 .2rem
  margin 0 .3rem
  img
    width 100%
    max-height: 500px
    max-width: 830px

</style>
